import type { Course, Session } from '@mc/api'
import { fetcher as originalFetcher } from 'libs/client/fetchers'
import type { CategoryShallow } from 'libs/server/api'
import * as palmTaxonomyClient from './palm-taxonomy/client'

type Client = {
  getCamps: (url: string) => Promise<Session[]>
  getCoursesByCategorySlug: (url: string) => Promise<Course[]>
  getCategories: (url: string) => Promise<CategoryShallow[]>
}

const createFetcher = (client: Client) => async (url: string) => {
  if (url.startsWith('/jsonapi/v1/camps')) {
    return client.getCamps(url)
  } else if (url.startsWith('/jsonapi/v1/courses?filter[category]')) {
    return client.getCoursesByCategorySlug(url)
  } else if (url.startsWith('/jsonapi/v1/categories')) {
    return client.getCategories(url)
  }
  return originalFetcher(url)
}

/** @deprecated */
export const palmTaxonomyFetcher = createFetcher(palmTaxonomyClient)

/** @deprecated */
export const getAltCategoriesFetcher = () => palmTaxonomyFetcher
/** @deprecated */
export const useAltCategoriesFetcher = () => palmTaxonomyFetcher
